<template lang="pug">
 el-form(
     label-width="150px",
     :model="userInfo",
     ref="userInfo",
     :rules="userInfoRules"
 )
    el-form-item(
      label="Tên đăng nhập",
      prop="account"
    )
      el-input.col-10(v-model="userInfo.account", name="name")
    el-form-item(
      label="Mật khẩu",
      prop="password"
    )
      el-input.col-10(v-model="userInfo.password", type="password", name="password")
    el-form-item(
      label="Nhập lại mật khẩu",
      prop="passwordRepeat"
    )
      el-input.col-10(v-model="userInfo.passwordRepeat", type="password", name="passwordRepeat")
    el-form-item.mb0
      .col-10
        el-button.col-12(type="danger", :loading="loading", @click="handleSignup") Đăng ký
</template>

<script>
import Vue from 'vue'
import Q from 'q'
import { Form, FormItem, Button, Input, Message } from 'element-ui'

Vue.use(Form)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(Input)

export default {
  name: 'signup',
  data () {
    let passwordRepeatRule = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Vui lòng nhập lại mật khẩu'))
      } else if (value !== this.userInfo.password) {
        callback(new Error('Mật khẩu không đúng'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      userInfo: {
        account: '',
        password: '',
        passwordRepeat: ''
      },
      userInfoRules: {
        account: [
          { required: true, message: 'Nhập tên đăng nhập', trigger: 'blur' },
          { min: 5, message: 'Tên đăng nhập giới hạn từ 5-20 ký tự', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Nhập mật khẩu', trigger: 'blur' },
          { min: 5, max: 20, message: 'Mật khẩu giới hạn từ 5-20 ký tự', trigger: 'blur' }
        ],
        passwordRepeat: [
          { required: true, message: 'Vui lòng nhập lại mật khẩu', trigger: 'blur' },
          { validator: passwordRepeatRule, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSignup () {
      this.loading = true
      Q.fcall(this.validateForm)
        .then(this.ajaxSignup)
        .catch(err => {
          console.log(err)
          this.loading = false
        })
    },
    validateForm (formName = 'userInfo') {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          throw new Error('validate Error')
        }
        return
      })
    },
    ajaxSignup () {
      this.$axios({
        url: '/vn/register',
        method: 'post',
        data: (() => {
          let { account, password } = this.userInfo
          return { account, password }
        })()
      })
        .then(res => {
          if (res.data.ret === 0) {
            this.$bus.emit('getLoginStat', '')
            this.$bus.emit('getUserInfo', this.userInfo)

            Message({
              message: 'Đăng ký thành công'
            })
          } else {
            throw new Error(res.data.msg)
          }
        })
        .catch(err => {
          this.loading = false
          Message({
            message: err.message,
            type: 'warning'
          })
        })
    }
  }
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// signup.vue?2dafb87e